import { Display3, Body1 } from '@sainsburys-tech/luna-typography'
import { Link } from 'react-router-dom'
import { useComponentContext } from '../../ComponentContext'
import { IProductInfo } from '../../../../../types/ComponentTypes/Components'

function ProductInfoComponent({
  productName,
  productCategory,
  skuNumber,
  eanNumber,
}: IProductInfo) {
  const componentContext = useComponentContext()

  return (
    <div id="s-reporting-productInfo">
      <Display3 id="s-reporting-productName" className="ln-u-flush" element="p">
        {productName}
      </Display3>
      <Body1 id="s-reporting-productInfo-body" element="p">
        in&nbsp;
        <span id="s-reporting-productCategory" className="ln-u-font-weight-bold">
          {productCategory}
        </span>
        <div>
          <span
            className="s-issuesummary-productSku ln-u-font-weight-bold"
            id="s-productSku"
          >
            {skuNumber}
          </span>
          {skuNumber !== '' && eanNumber !== '' ? ' / ' : ''}
          <span
            className="s-issuesummary-productBarcode ln-u-color-grey"
            id="s-productBarCode"
          >
            {eanNumber}
          </span>
        </div>
      </Body1>
      <Link
        to="/reporting"
        onClick={componentContext.handleBack}
        id="s-reporting-productInfo-link"
        className="ln-u-font-weight-bold"
      >
        Not the right product?
      </Link>
    </div>
  )
}

export default ProductInfoComponent
